module.exports = __webpack_public_path__ + "img/4@2x.eb537d07.png";